import { Badge, Table } from 'antd';
import { FilterIcon } from 'components/Filters/FilterIcon';
import { RangePickerFilter } from 'components/Filters/RangePickerFilter';
import { bccNestedColumns } from 'components/PaymentsInfoTables/datasource';
import {
  COLUMN_EXTRA_LARGE,
  COLUMN_MEDIUM,
  PAGE_SIZE_OPTIONS,
  SCROLL_Y,
} from 'constants/table';
import { useState } from 'react';
import { formatDate } from 'utils';
import { priceRender, renderWithTooltip } from 'utils/table';

function BccPaymentetsRefundTable({
  f_date,
  t_date,
  handleDateFilter,
  payments,
  loading,
  openDrawer,
}) {
  const [bccActiveRowReports, setBccActiveRowReports] = useState([]);
  const [bccExpandedKey, setBccExpandedKey] = useState([]);

  const columns = [
    {
      title: 'Клиент',
      key: 'company_name',
      dataIndex: 'company_name',
      width: COLUMN_EXTRA_LARGE,
    },
    {
      title: 'Номер отправленный в БЦК',
      key: 'extRefNo',
      dataIndex: 'extRefNo',
    },
    {
      title: 'Причина возврата',
      width: COLUMN_EXTRA_LARGE,
      key: 'returnNote',
      dataIndex: 'returnNote',
      render: (text) => renderWithTooltip(text, 70),
    },
    {
      title: 'Дата отработки',
      key: 'finishDate',
      dataIndex: 'finishDate',
      width: COLUMN_MEDIUM,
      render: (text) => formatDate(text, 'DD.MM.YYYY hh:mm:ss'),
    },
    {
      title: 'Статус',
      key: 'status',
      dataIndex: 'status',
      width: COLUMN_MEDIUM,
      render: (text) => {
        switch (text) {
          case 'done':
            return <Badge text="Переотправлен в БЦК" status="success" />;
          case 'refund_client':
            return <Badge text="Возвращен клиенту" status="warning" />;
          case 'income':
            return <Badge text="Отработано" status="success" />;
          case 'new':
            return <Badge text="Нерешенный" status="default" />;
          default:
            return <Badge text={text} status="default" />;
        }
      },
    },
    {
      title: 'Комментарий',
      key: 'comment',
      dataIndex: 'comment',
      width: COLUMN_MEDIUM,
      render: renderWithTooltip,
    },

    {
      title: 'Общая сумма',
      key: 'amount',
      dataIndex: 'amount',
      render: priceRender,
    },
    {
      title: 'Сумма возврата',
      key: 'returnAmount',
      dataIndex: 'returnAmount',
      render: priceRender,
    },
    {
      title: 'Дата возврата',
      key: 'returnDate',
      dataIndex: 'returnDate',
      render: (text) => formatDate(text, 'DD.MM.YYYY hh:mm:ss'),
      filterDropdown: () => {
        return (
          <RangePickerFilter
            value={[f_date, t_date]}
            onFilterChange={handleDateFilter}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={f_date && t_date} />,
    },
  ];

  const renderBccReportTable = () => {
    return (
      <Table
        className="nested-table"
        columns={bccNestedColumns}
        rowKey="ref"
        dataSource={bccActiveRowReports}
        tableLayout="fixed"
        pagination={false}
      />
    );
  };

  const handleBccRowExpand = (expanded, record) => {
    if (expanded) {
      setBccActiveRowReports(record?.reportRows ?? []);
      setBccExpandedKey([record.id]);
    } else {
      setBccExpandedKey([]);
    }
  };

  return (
    <Table
      columns={columns}
      tableLayout="fixed"
      onRow={(record) => {
        return {
          onDoubleClick: () =>
            openDrawer({
              ...record,
              amount: priceRender(record.amount),
              returnAmount: priceRender(record.returnAmount),
              createDate: formatDate(record.createDate, 'DD.MM.YYYY hh:mm:ss'),
              processed_date: formatDate(
                record.processed_date,
                'DD.MM.YYYY hh:mm:ss'
              ),
              send_date: formatDate(record.send_date, 'DD.MM.YYYY hh:mm:ss'),
            }),
        };
      }}
      pagination={{
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      expandable={{
        expandedRowRender: renderBccReportTable,
        onExpand: handleBccRowExpand,
        expandedRowKeys: bccExpandedKey,
      }}
      dataSource={payments}
      loading={loading}
      scroll={{ x: 1800, y: SCROLL_Y }}
      rowKey="id"
    />
  );
}

export default BccPaymentetsRefundTable;
